export default {
  filter: 'Filtrar',
  resize: 'Redimensionar',
  expand: 'Ampliar',
  duplicate: 'Duplicar',
  remove: 'Eliminar',
  averageTime: 'Tiempo promedio',
  atTime: 'a las',
  weekOf: 'Semana del',
};
